import { apiGetArcade, apiPostArcade, apiPutArcade } from './api';
import { Arcade } from './interfaces';
import { getArcadeId } from './selectors';
import * as types from './types';

export const setArcade = arcade => ({ type: types.ARCADE__SET_ARCADE, arcade });
export const setArcadeValue = <T extends keyof Arcade>(name: T, value: Arcade[T]) =>
    ({ type: types.ARCADE__SET_ARCADE_VALUE, name, value });

export const getArcade = (arcadeId?: string) => (dispatch, getState) => {
    arcadeId = arcadeId || getArcadeId(getState());
    if (!arcadeId) {
        throw new Error('No arcade is being edited');
    }
    return apiGetArcade(arcadeId).then(
        results => {
            dispatch(setArcade(results));
        }
    );
};

export const createArcade = arcade => (dispatch) => {
    return apiPostArcade(arcade).then(
        results => !!results && dispatch(getArcade(results.id))
    );
};
export const updateArcade = (arcade, arcadeId) => (dispatch) => {
    return apiPutArcade(arcade, arcadeId).then(
        results => {
            dispatch(getArcade(results.id));
        }
    );
};

export const clearArcadeArcade = () => ({ type: types.ARCADE__CLEAR_ARCADE });
